import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RoutesList from '@/components/RoutesList.vue';
let CharactersPage = class CharactersPage extends Vue {
    get categories() {
        return [
            {
                category: '',
                routes: [
                    { to: '/characters/species', title: 'Species' },
                    { to: '/characters/classes', title: 'Classes' },
                    { to: '/characters/archetypes', title: 'Archetypes' },
                    { to: '/characters/backgrounds', title: 'Backgrounds' },
                    { to: '/characters/feats', title: 'Feats' },
                    { to: '/characters/customizationOptions', title: 'Customization Options' },
                    { to: '/characters/forcePowers', title: 'Force Powers' },
                    { to: '/characters/techPowers', title: 'Tech Powers' },
                    { to: '/characters/maneuvers', title: 'Maneuvers' }
                ]
            }
        ];
    }
};
CharactersPage = __decorate([
    Component({
        components: {
            RoutesList
        }
    })
], CharactersPage);
export default CharactersPage;
